import { call, put, takeLatest } from "redux-saga/effects";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import {
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFail,
} from "../reducer";
import { httpPostPasswordReset } from "../../../services/passwordRecovery";

export function* resetPassword({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpPostPasswordReset, data);

  const { success, raw, message, statusCode } = response;
  if (success) {
    yield put(resetPasswordSuccess(raw));
    if (callback) {
      callback();
    }
  } else {
    yield put(resetPasswordFail(message));
    networkErrorHandler(statusCode, message || raw);
  }
}

export default function* onResetPasswordStart() {
  yield takeLatest(resetPasswordStart.type, resetPassword);
}
